<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field v-model="filterCustomerRepair.Number" label="變更單號" />
          </v-col>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterCustomerRepair"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              :loading="isLoadingCustomerRepair"
              @click="getUpdateCustomerRepair"
            >
              {{ $t('common_search') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="updateCustomerRepairDataTableHeaders"
      :items="updateCustomerRepairList"
      class="elevation-1 mt-5"
      :loading="isLoadingCustomerRepair"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
      :sort-by="['CustomerNumber']"
      :sort-desc="[false]"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_repair_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-dialog v-model="isShowEditCustomerRepairDialog" fullscreen persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2 ml-8" v-bind="attrs" v-on="on">
                {{ $t('common_new') }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_edit') }}</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-btn
                    color="primary"
                    @click="isConfirmUpdateCustomerRepairBtn"
                    :disabled="
                      editedUpdateCustomerRepair.IsConfirmChange ||
                        editedUpdateCustomerRepairIndex === -1 ||
                        isAllTextFieldDisable
                    "
                    class="mx-2"
                  >
                    確認變更
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <ValidationObserver ref="customerRepair">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        lg="6"
                        xl="6"
                        v-if="editedUpdateCustomerRepairIndex !== -1"
                      >
                        <v-text-field
                          label="變更單號"
                          v-model="editedUpdateCustomerRepair.Number"
                          disabled
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <customer-autocomplete
                          refName="customerAutocomplete"
                          :fatherEditedCustomer="editedUpdateCustomerRepair"
                          :editedCustomerIndex="-1"
                          :customerName="'quotation_customer_number'"
                          @setCustomer="setCustomer"
                          @keyupEnter="focusNextInput"
                          v-if="editedUpdateCustomerRepairIndex === -1"
                        />
                        <ValidationProvider
                          :name="$t('quotation_customer_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedUpdateCustomerRepair.CustomerNumber"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_customer_number') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('quotation_shortname')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedUpdateCustomerRepair.CustomerName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_shortname') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('quotation_full_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedUpdateCustomerRepair.CustomerFullName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('quotation_full_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-tabs v-model="tabValue">
                <v-tab href="#tab-1">Item</v-tab>
                <v-tab href="#tab-2">BOM</v-tab>
                <v-tab href="#tab-3">BOM細項</v-tab>
                <v-spacer></v-spacer>
                <select-repair-price-item
                  v-if="tabValue === 'tab-1'"
                  :isAllTextFieldDisable="
                    isAllTextFieldDisable || editedUpdateCustomerRepair.IsConfirmChange
                  "
                  :customerId="editedUpdateCustomerRepair.CustomerId"
                  @addSelectCustomerRepairItems="addSelectCustomerRepairItems"
                />
                <select-repair-price-bom
                  v-if="tabValue === 'tab-2'"
                  :isAllTextFieldDisable="
                    isAllTextFieldDisable || editedUpdateCustomerRepair.IsConfirmChange
                  "
                  :customerId="editedUpdateCustomerRepair.CustomerId"
                  @addSelectCustomerRepairBoms="addSelectCustomerRepairBoms"
                />
                <select-repair-price-bom-item
                  v-if="tabValue === 'tab-3'"
                  :isAllTextFieldDisable="
                    isAllTextFieldDisable || editedUpdateCustomerRepair.IsConfirmChange
                  "
                  :customerId="editedUpdateCustomerRepair.CustomerId"
                  @addSelectCustomerRepairBomItems="addSelectCustomerRepairBomItems"
                />
                <v-tab-item value="tab-1">
                  <update-customer-repair-item
                    :customerRepairItems="editedUpdateCustomerRepair.CustomerRepairItems"
                    :isAllTextFieldDisable="
                      isAllTextFieldDisable || editedUpdateCustomerRepair.IsConfirmChange
                    "
                    @setEditedCustomerRepairItemIndex="setEditedCustomerRepairItemIndex"
                    @addEditedCustomerRepairItem="addEditedCustomerRepairItem"
                    @confirmDeleteCustomerRepairItem="confirmDeleteCustomerRepairItem"
                  />
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <update-customer-repair-bom
                    :customerId="editedUpdateCustomerRepair.CustomerId"
                    :customerRepairBoms="editedUpdateCustomerRepair.CustomerRepairBoms"
                    :isAllTextFieldDisable="
                      isAllTextFieldDisable || editedUpdateCustomerRepair.IsConfirmChange
                    "
                    @setEditedCustomerRepairBomIndex="setEditedCustomerRepairBomIndex"
                    @addEditedCustomerRepairBom="addEditedCustomerRepairBom"
                    @confirmDeleteCustomerRepairBom="confirmDeleteCustomerRepairBom"
                  />
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <update-customer-repair-bom-item
                    :customerId="editedUpdateCustomerRepair.CustomerId"
                    :customerRepairBomItems="editedUpdateCustomerRepair.CustomerRepairBomItems"
                    :isAllTextFieldDisable="
                      isAllTextFieldDisable || editedUpdateCustomerRepair.IsConfirmChange
                    "
                    @setEditedCustomerRepairBomItemIndex="setEditedCustomerRepairBomItemIndex"
                    @addEditedCustomerRepairBomItem="addEditedCustomerRepairBomItem"
                    @confirmDeleteCustomerRepairBomItem="confirmDeleteCustomerRepairBomItem"
                  />
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedCustomerRepair"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedCustomerRepair"
                  :loading="isLoadingSaveBtn"
                  :disabled="editedUpdateCustomerRepair.IsConfirmChange || isAllTextFieldDisable"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteCustomerRepairDialog"
            :deleteMessage="'common_delete'"
            @closeDelete="closeDeleteCustomerRepair"
            @confirmDelete="confirmDeleteCustomerRepair"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.UpdateTime`]="{ item }">
        {{ convertToDateTimeFormat(item.UpdateTime) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditCustomerRepairDialogBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon @click="isShowDeleteCustomerRepairDialogBtn(item)" v-if="!item.IsConfirmChange">
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import { HttpUpdateCustomerRepair } from '@/js/http-Manager'
import { mapGetters } from 'vuex'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import UpdateCustomerRepairItem from '@/components/CustomerRepair/UpdateCustomerRepairItem.vue'
import SelectRepairPriceItem from '@/components/CustomerRepair/SelectRepairPriceItem.vue'
import UpdateCustomerRepairBom from '@/components/CustomerRepair/UpdateCustomerRepairBom.vue'
import SelectRepairPriceBom from '@/components/CustomerRepair/SelectRepairItemBom.vue'
import SelectRepairPriceBomItem from '@/components/CustomerRepair/SelectRepairPriceBomItem.vue'
import UpdateCustomerRepairBomItem from '@/components/CustomerRepair/UpdateCustomerRepairBomItem.vue'
export default {
  components: {
    DeleteDialog,
    CustomerAutocomplete,
    CustomerAutocompleteFilter,
    UpdateCustomerRepairItem,
    SelectRepairPriceItem,
    UpdateCustomerRepairBom,
    SelectRepairPriceBom,
    SelectRepairPriceBomItem,
    UpdateCustomerRepairBomItem
  },
  props: {
    fatherTabValue: {
      type: String,
      default: 'tab-1'
    }
  },
  name: 'UpdateOneCustomerRepair',
  data: () => ({
    tabValue: 'tab-1',
    isShowEditCustomerRepairDialog: false,
    isShowDeleteCustomerRepairDialog: false,
    updateCustomerRepairList: [],
    editedUpdateCustomerRepairIndex: -1,
    searchCustomerRepair: '',
    editedUpdateCustomerRepair: {
      IsConfirmChange: false,
      Number: '',
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      UpdateTime: 0,
      CustomerRepairItems: [],
      CustomerRepairBoms: [],
      CustomerRepairBomItems: []
    },
    defaultCustomerRepair: {
      IsConfirmChange: false,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      UpdateTime: 0,
      CustomerRepairItems: [],
      CustomerRepairBoms: [],
      CustomerRepairBomItems: []
    },
    isLoadingCustomerRepair: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    totalRows: 0,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: true,
    filterCustomerRepair: {
      Number: '',
      CustomerId: ''
    },
    editedCustomerRepairItemIndex: -1,
    editedCustomerRepairBomIndex: -1,
    editedCustomerRepairBomItemIndex: -1
  }),
  watch: {
    async fatherTabValue (val) {
      if (val === 'tab-1') {
        await this.getUpdateCustomerRepair()
        await this.countTotalRows()
      }
    }
  },
  async mounted () {
    await this.getUpdateCustomerRepair()
    await this.countTotalRows()
  },
  computed: {
    customerRepairDialogTitle () {
      return this.editedUpdateCustomerRepairIndex === -1
        ? this.$t('customer_repair_add_card_title')
        : this.$t('customer_repair_edited_card_title')
    },
    updateCustomerRepairDataTableHeaders () {
      return [
        { text: '變更單號', align: 'start', value: 'Number' },
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber'
        },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        { text: this.$t('item_update_time'), align: 'center', value: 'UpdateTime' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },

    ...mapGetters('login', {
      getUserAccountId: 'getUserAccountId'
    }),
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },

    async setCustomer (val) {
      this.editedUpdateCustomerRepair.CustomerId = val.Id
      this.editedUpdateCustomerRepair.CustomerNumber = val.Number
      this.editedUpdateCustomerRepair.CustomerName = val.ShortName
      this.editedUpdateCustomerRepair.CustomerFullName = val.FullName
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    async setFilterCustomer (val) {
      this.filterCustomerRepair.CustomerId = val.Id
      this.filterCustomerRepair = JSON.parse(JSON.stringify(this.filterCustomerRepair))
    },

    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          number: this.filterCustomerRepair.Number,
          customerId: this.filterCustomerRepair.CustomerId
        }
        if (this.countTotalRowsSource) {
          this.countTotalRowsSource.cancel('cancel')
        }
        let cancelToken = axios.CancelToken
        this.countTotalRowsSource = cancelToken.source()
        let response = await HttpUpdateCustomerRepair.GetUpdateCustomerRepairCount(
          param,
          this.countTotalRowsSource.token
        )
        if (response) {
          this.totalRows = response.status === 200 ? response.data.Data : 0
        }
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getUpdateCustomerRepair(val)
    },
    async getUpdateCustomerRepair (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingCustomerRepair = true

      let param = {
        Number: this.filterCustomerRepair.Number,
        CustomerId: this.filterCustomerRepair.CustomerId,
        ItemsPerPage: val && val.itemsPerPage ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: val && val.page ? val.page : this.currentOptions.page,
        SortBy: val && val.sortBy ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: val && val.sortDesc ? val.sortDesc[0] : this.currentOptions.sortDesc[0]
      }
      let response = await HttpUpdateCustomerRepair.GetUpdateCustomerRepairDtoAsync(param)
      this.isLoadingCustomerRepair = false
      this.updateCustomerRepairList = response && response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    async saveEditedCustomerRepair () {
      const isValid = await this.$refs.customerRepair.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingCustomerRepair = true

        if (this.editedUpdateCustomerRepairIndex > -1) {
          await HttpUpdateCustomerRepair.UpdateCustomerRepair(this.editedUpdateCustomerRepair)
        } else {
          await HttpUpdateCustomerRepair.AddCustomerRepair(this.editedUpdateCustomerRepair)
        }
        this.closeEditedCustomerRepair()
      }
    },
    async closeEditedCustomerRepair () {
      this.isLoadingCustomerRepair = true
      await this.getUpdateCustomerRepair()
      this.isShowEditCustomerRepairDialog = false
      this.isLoadingCustomerRepair = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultCustomerRepair)
        this.editedUpdateCustomerRepair = JSON.parse(str)
        this.editedUpdateCustomerRepairIndex = -1
        this.$refs.customerRepair.reset()
      })
    },
    async isShowEditCustomerRepairDialogBtn (item) {
      this.editedUpdateCustomerRepairIndex = this.updateCustomerRepairList.indexOf(item)
      let str = JSON.stringify(item)
      this.editedUpdateCustomerRepair = JSON.parse(str)
      this.isShowEditCustomerRepairDialog = true
    },
    async isShowDeleteCustomerRepairDialogBtn (item) {
      this.editedUpdateCustomerRepairIndex = this.updateCustomerRepairList.indexOf(item)
      this.isShowDeleteCustomerRepairDialog = true
    },
    async confirmDeleteCustomerRepair () {
      this.isAllTextFieldDisable = true
      this.isLoadingCustomerRepair = true
      this.isLoadingSaveBtn = true
      await HttpUpdateCustomerRepair.DeleteCustomerRepair(
        this.updateCustomerRepairList[this.editedUpdateCustomerRepairIndex].Id
      )
      this.closeDeleteCustomerRepair()
    },
    async closeDeleteCustomerRepair () {
      this.isShowDeleteCustomerRepairDialog = false
      this.isAllTextFieldDisable = false
      this.isLoadingSaveBtn = false
      this.isLoadingCustomerRepair = false
      this.$nextTick(() => {
        this.editedUpdateCustomerRepairIndex = -1
      })
      await this.getUpdateCustomerRepair()
    },
    setEditedCustomerRepairItemIndex (val) {
      this.editedCustomerRepairItemIndex = val
    },
    async addEditedCustomerRepairItem (val) {
      this.editedUpdateCustomerRepair.CustomerRepairItems.splice(
        this.editedCustomerRepairItemIndex,
        1,
        val
      )
    },
    confirmDeleteCustomerRepairItem (val) {
      this.editedUpdateCustomerRepair.CustomerRepairItems.splice(val, 1)
    },
    setEditedCustomerRepairBomIndex (val) {
      this.editedCustomerRepairBomIndex = val
    },
    addEditedCustomerRepairBom (val) {
      this.editedUpdateCustomerRepair.CustomerRepairBoms.splice(
        this.editedCustomerRepairBomIndex,
        1,
        val
      )
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    addEditedCustomerRepairBomItem (val) {
      this.editedUpdateCustomerRepair.CustomerRepairBomItems.splice(
        this.editedCustomerRepairBomItemIndex,
        1,
        val
      )
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    confirmDeleteCustomerRepairBom (val) {
      this.editedUpdateCustomerRepair.CustomerRepairBoms.splice(val, 1)
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    addSelectCustomerRepairItems (val) {
      this.editedUpdateCustomerRepair.CustomerRepairItems = val
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    addSelectCustomerRepairBoms (val) {
      this.editedUpdateCustomerRepair.CustomerRepairBoms = val
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    addSelectCustomerRepairBomItems (val) {
      this.editedUpdateCustomerRepair.CustomerRepairBomItems = val
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    confirmDeleteCustomerRepairBomItem (val) {
      this.editedUpdateCustomerRepair.CustomerRepairBomItems.splice(val, 1)
      this.editedUpdateCustomerRepair = JSON.parse(JSON.stringify(this.editedUpdateCustomerRepair))
    },
    setEditedCustomerRepairBomItemIndex (val) {
      this.editedCustomerRepairBomItemIndex = val
    },
    async isConfirmUpdateCustomerRepairBtn () {
      this.isAllTextFieldDisable = true
      this.editedUpdateCustomerRepair.IsConfirmChange = true
      await HttpUpdateCustomerRepair.ThrowUpdateCustomerRepair(this.editedUpdateCustomerRepair)
      this.isAllTextFieldDisable = false
      this.closeEditedCustomerRepair()
    }
  }
}
</script>
